
import { defineComponent } from "vue";
import {transactionhistory, getFifthPairOptionDetails, saveFifthPairOption}  from "@/api/transaction";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default defineComponent({
  name: "kt-widget-11", 
  methods: {
    async transactionhistory(){ 
      this.loading = true;
      const response = await transactionhistory(1);
      this.list = response.data.pageList;
      this.loading = false;
    },
    async getFifthPairOptionDetailsFN(){
      const response = await getFifthPairOptionDetails();
      this.pr_5th = response.data.fifthPairLastOption;
      this.isAllowedFifthPairOption = response.data.isAllowedFifthPairOption;
    },

    async saveFifthPairOptionFN(){
      var params = {"pr_5th" : this.pr_5th}
      const response = await saveFifthPairOption(params);
       if(response != null){
          this.loading = false;
          if (response.data.result == "SUCCESS") {
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "success",
              confirmButtonClass: "btn btn-secondary"
            }); 
           // window.location.reload();
            return; 
          } else if(response.data.result == "FAILED"){
            Swal.fire({
              title: "",
              text: response.data.message,
              icon: "error",
              confirmButtonClass: "btn btn-secondary"
            }); 
            return; 
          }
        }
      
    }

  },
  mounted(){
      this.transactionhistory();
      this.getFifthPairOptionDetailsFN();
  },
  data(){
      return { 
        list : [],
        loading: true,
        pr_5th : "GC",
        isAllowedFifthPairOption : false,
      }
  },
  components: {},
  props: {
    widgetClasses: String
  }
});
